import { forwardRef } from 'react';
import {
    NavLink as RouterLink,
    LinkProps as RouterLinkProps,
} from 'react-router-dom';

const MUILink = forwardRef<
    HTMLAnchorElement,
    Omit<RouterLinkProps, 'to'> & { href: RouterLinkProps['to'] }
>((props, ref) => {
    const { href, ...other } = props;
    return <RouterLink ref={ref} to={href} {...other} />;
});

export default MUILink;
